<template>

    <div v-if="showModal" @click.self="hide" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/4 bg-white rounded-lg mx-6">
  
        <div class="rg-modal-header">
          Request Review
  
          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="hide"><i class="mdi mdi-close"></i></a>
        </div>
  
        <div class="p-6">
  
          <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">
            {{success}}
          </div>
  
          <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
            <div v-html="error"></div>
          </div>
  
          <div v-if="!me.convertly_enabled">
            <product-access-required product="convertly" />
          </div>
          <div v-else>
            <div class="mb-3">
              <v-rating size="30" v-model="rating_value" color="amber" disabled></v-rating>
            </div>


    
            <div class="mb-3">
                  <p class="mb-1 text-xs mb-2"><strong>
                      Your Google Business Profile Review Link
                  </strong></p>

                  <div v-if="gettingReviewLink">
                      <input disabled :placeholder="'Please wait while we are trying to generate your link...'" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text">
                  </div>
                  <div v-else>
                      <input v-model="google_review_link" :placeholder="'https://search.google.com/local/writereview?placeid='" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text">
                  </div>
            </div>
    
            <p class="text-xs text-gray-700 mb-4">We will send this link to your customers so they can easily click and leave a review on Google. Feel free to update the link if necessary or incomplete.</p>
    
            <div class="mb-3">
              <p class="mb-1 text-xs mb-2"><strong>
                Review Prompt
              </strong></p>
              <textarea name="" id="" rows="10" v-model="review_prompt" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="border-style: solid; height: 200px;"></textarea>
            </div>
    
            <p class="text-xs text-gray-700 mb-4">Feel free to edit this prompt based on your business needs.</p>
    
            <div class="mb-3">
              <p class="mb-1 text-xs mb-2"><strong>
                Phone Numbers
              </strong></p>
              <textarea name="" id="" rows="10" v-model="phone_numbers" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="border-style: solid; height: 100px;" placeholder="+12345678901"></textarea>
            </div>
    
            <p class="text-xs text-gray-700 mb-4">Enter phone numbers to dial and request reviews from. One per line.</p>

            <v-checkbox
              v-model="consent"
            >
              <template v-slot:label>
                <span class="text-gray-700">I confirm that the provided phone numbers agreed to receive calls (including automated or AI-driven calls) for service feedback</span>
              </template>
            </v-checkbox>
          </div>
  
        </div>
  
        <div class="bg-gray-100 rounded-b-lg px-6 py-4">
  
          <button v-show="me.convertly_enabled" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': saving}" @click="sendReviewRequest('sms')">
              REQUEST BY SMS
          </button>
          
          <button v-show="me.convertly_enabled" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 mr-2 float-right" :class="{'spinner': saving}" @click="sendReviewRequest('voice')">
              REQUEST BY VOICE
          </button>
  
          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="hide">
              CANCEL
          </button>
  
          <div class="clearfix"></div>
  
        </div>
  
      </div>
    </div>
  
  </template>
  
  <script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'
  
  export default {
    components: {
      ProductAccessRequired
    },
    data: function() {
      return {
        showModal: false,
        saving: false,
        success: null,
        error: null,

        rating_value: 5,

        review_prompt: "",

        phone_numbers: "",

        gettingReviewLink: false,

        google_review_link: "https://search.google.com/local/writereview?placeid=",

        consent: false
      }
    },
    computed: {
        ...mapState({
            me: state => state.me.me,
        })
    },
    methods: {
      show() {
        this.showModal = true
      },
      hide() {
        this.showModal = false
        this.saving = false
      },
      async sendReviewRequest(method) {
        if (!this.review_prompt)
            return;

        if (!this.phone_numbers)
            return;

        if (!this.consent) {
          if (!this.platform_url) {
            this.$swal({
                title: "",
                text: "Please confirm that the provided phone numbers agreed to receive calls (including automated or AI-driven calls) for service feedback!",
                showCancelButton: false,
                icon: 'error',
            });

            return;
          }
        }

        this.saving = true
        this.error = null
        try {
          await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/reviews/request-review`, {
                prompt: this.review_prompt,
                phone_numbers: this.phone_numbers,
                method: method
          }, {
              headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          })
  
          //this.hide()
          this.hide()

          this.phone_numbers = "";
          this.error = null
  
        } catch (e) {
            console.log(e.response.data);
            this.error = e.response.data.message
        }
        this.saving = false

        this.$swal({
            title: "Requested!",
            text: "Review requests have been sent to the phone numbers provided!",
            showCancelButton: false,
        });
      },

      setPhoneNumbers(numbers) {
        this.phone_numbers = numbers.join("\n");
      },

        async getGooglePlaceId() {
            this.gettingReviewLink = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-google-placeid`, {
                
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            this.google_review_link = 'https://search.google.com/local/writereview?placeid=' + response.data.place_id;

            this.gettingReviewLink = false;
        }
    },

    created() {
      this.review_prompt = `You are Mike, a representative of a business named "` + this.me.company_name + `" offering "` + this.me.main_keyword + `" and you are calling the customer to thank them and follow up on their recent experience.

  You have to make sure that the tone you maintain is conversational, friendly, and professional.

  Here are some rules to abide by at all times:
  - Keep your responses short, concise, and natural, maintaining a warm and professional tone.

  SCRIPT:
  Follow this flow naturally during the call:

  Step 1. Greet the customer, introduce yourself, and ask how satisfied they were with your recent services.

  Step 2. If they had a positive experience, ask them if there is any specific feedback they can share about what went well or what benefits they received. (This helps us craft a personalized review draft for them).

  Step 3. Briefly dictate a short, 1-2 sentence review draft based on their feedback directly on the spot so they know what it sounds like.

  Step 4. Let them know you are sending them a text message right now with a link to leave a review. Use verbiage like: "Please let others know about your 5-star experience by leaving a review—or we helped write one for you in the text message so you can just copy and paste it!"

  Step 5. Thank them for their time and business, and wish them a great day.

  Important Rule: If the customer indicates they had a bad experience, DO NOT send a review link or mention leaving a review. Instead, apologize sincerely and ask if they would like to be transferred to a representative using the following details for a warm transfer:
  - Name: ` + this.me.first_name + `
  - Phone Number: ` + this.me.phone + `

  Let the customer know that they will be transferred to ` + this.me.first_name + ` and to please hold while the call is connected.`;


      if (!this.me.google_place_id) {
          this.getGooglePlaceId();
      }
      else {
          this.google_review_link = 'https://search.google.com/local/writereview?placeid=' + this.me.google_place_id;
      }
    }
  }
  </script>